import { useState } from "react";

import LiffButton from "./components/LiffButton";
import SmsCodeInput from "./components/SmsCodeInput";
import SmsResend from "./components/SmsResend";

interface SmsVerificationProps {
  isResending: boolean;
  onVerify: (verificationCode: string) => void;
  onResend: () => Promise<boolean>;
}

export default function SmsVerification({
  isResending,
  onVerify,
  onResend,
}: SmsVerificationProps) {
  const [verificationCode, setVerificationCode] = useState("");

  const isVerificationCodeValid = verificationCode.length === 4;

  const handleVerify = () => {
    if (!isVerificationCodeValid) return;

    onVerify(verificationCode);
  };

  return (
    <main className="flex flex-1 flex-col items-center pt-[217px]">
      <h1 className="text-[38px] font-bold leading-[48px]">手機驗證</h1>

      <p className="mt-8 text-[24px] font-bold leading-[48px]">
        驗證碼已發送至您的手機
      </p>

      <div className="mt-4">
        <SmsCodeInput value={verificationCode} onChange={setVerificationCode} />
      </div>

      <LiffButton
        className="mt-6"
        disabled={!isVerificationCodeValid}
        onClick={handleVerify}
      >
        確認驗證
      </LiffButton>

      <div className="mt-6">
        <SmsResend isResending={isResending} onResend={onResend} />
      </div>
    </main>
  );
}
